import { useEffect, useState } from "react";
import { Container, Table, Card, Badge, Spinner } from "react-bootstrap";

export default function Registry() {
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/days/registry", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then(res => res.json())
      .then(data => {
        setDays(data);
        setLoading(false);
      });
  }, []);

  return (
    <Container className="mt-5">
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title className="fs-3 mb-3">📅 Registry</Card.Title>

          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : days.length === 0 ? (
            <p className="text-muted text-center py-4">
              No days have been registered yet.
            </p>
          ) : (
            <Table hover responsive className="align-middle">
              <thead className="table-light">
                <tr>
                  <th>Date</th>
                  <th>Owner</th>
                </tr>
              </thead>
              <tbody>
                {days.map(day => (
                  <tr key={day._id}>
                    <td className="fw-semibold">{day.date}</td>
                    <td>
                      <Badge bg="primary" pill>
                        {day?.owner?.email}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
}
